export const stripPrefix = (path: string, locale: string) =>
  path.replace(new RegExp(`^/${locale}(/.*)?$`), '$1');
